import { useEffect } from 'react';

import { LoadingScreen } from '@/modules/ui';

import { redirectToUrl } from '../utils/redirectToUrl';

import { NormalAccountCreationScreen } from './NormalAccountCreationScreen';

// Terminal PURL redirect for an `invalid` / `already_enrolled` token — the backend
// returns a `redirectUrl` (a login / bad-link landing page). In production we
// navigate there, showing a loader while the hand-off completes. Local dev has no
// login app to navigate to, so we render the normal account-creation screen with
// its sign-in sheet auto-opened over it — the member already has an account, so
// signing in is the intended next step (matching useSignIn's dev convention).
export function PurlRedirectScreen({ redirectUrl }: { redirectUrl: string }) {
  useEffect(() => {
    if (__DEV__) return;
    // Same-tab navigation on web (a new tab would strand the user on this loader);
    // Linking on native.
    redirectToUrl(redirectUrl);
  }, [redirectUrl]);

  if (__DEV__) {
    return <NormalAccountCreationScreen autoOpenSignIn />;
  }

  return <LoadingScreen />;
}
